import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'antd';
import Rule from './Rule';

const KeepInMind = ({ name, formKeepInMinds, isEdit, }) => {
  let rules = useSelector((state) => state.space?.rules?.data?.rules || []);
  
  if(isEdit && formKeepInMinds) {
    const filterdRules = []
    rules.forEach((element, index) => {
      filterdRules.push(element)
      formKeepInMinds.forEach(k_minds => {
        if (element?.id === k_minds.rule?.id && !k_minds.isDisabled){
          filterdRules[index] = ({...element, value:k_minds });
        }
      })
    });
    rules = filterdRules;
  }
  // console.log("rules", rules);
  return (
      <>
      <h3>Space Rules</h3>
        <div className="amenities-checkbox-wrapper">
          {rules.map((rule, index) => {

          const formIndex = formKeepInMinds?.findIndex(k_mind => {
            const formRuleId = typeof k_mind.rule === 'string' 
              ? k_mind.rule 
              : k_mind.rule?.id;
            return rule.id === formRuleId;
          }) ?? index;
          
            return (
              <Form.Item key={rule.id} name={[...name, formIndex]}>
                <Rule key={rule.id} name={rule.name} ruleId={rule.id} index={formIndex} isEdit={isEdit}  value={rule.value} />
              </Form.Item>
            );
          })}
        </div>
      </>
  );
};

export default KeepInMind;
